(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-properties"] && !Shopify.designMode) return;
  try {
    (() => {
    let tooltip = null;
    let activeTarget = null;

    function getTooltipContainer(trigger) {
      return trigger.closest('dialog') || document.body;
    }

    function getOrCreateTooltip(trigger) {
      const container = getTooltipContainer(trigger);

      // If the tooltip already exists but is sitting in the wrong container
      // (e.g. it was first created for a trigger outside a dialog, and now
      // we need it inside one, or vice versa), move it.
      if (tooltip && tooltip.parentElement !== container) {
        tooltip.remove();
        tooltip = null;
      }

      if (!tooltip) {
        tooltip = document.createElement('span');
        tooltip.className = 'variant-option__tooltip';
        tooltip.setAttribute('role', 'tooltip');
        container.appendChild(tooltip);
      }

      return tooltip;
    }

    function showTooltip(trigger) {
      const tip = getOrCreateTooltip(trigger);
      const container = getTooltipContainer(trigger);

      tip.innerHTML = `<p>${trigger.dataset.tooltip}</p>`;
      tip.classList.add('is-visible');

      const containerRect =
        container === document.body ? { left: 0, top: 0, width: window.innerWidth, height: window.innerHeight } : container.getBoundingClientRect();

      const rect = trigger.getBoundingClientRect();
      const tipRect = tip.getBoundingClientRect();

      const naturalLeft = (rect.left - containerRect.left) + rect.width / 2 - tipRect.width / 2;
      let left = naturalLeft;
      let top = (rect.top - containerRect.top) - tipRect.height - 8;

      // Clamp horizontally within the container's own bounds. With small
      // (e.g. 32x32) triggers packed tightly in a row, the tooltip is wider
      // than the trigger and will frequently need clamping near the edges.
      const maxLeft = containerRect.width - tipRect.width - 8;
      left = Math.min(Math.max(8, left), Math.max(8, maxLeft));

      // If there isn't room above the trigger, flip the tooltip below it.
      let flipped = false;
      if (top < 8) {
        top = (rect.top - containerRect.top) + rect.height + 8;
        flipped = true;
      }

      // The arrow is centered on the tooltip box by default (left: 50%).
      // When clamping shifts the tooltip away from its natural centered
      // position, shift the arrow back by the same amount so it still
      // points at the trigger instead of drifting off into empty space.
      const arrowShift = naturalLeft - left;
      tip.style.setProperty('--tooltip-arrow-shift', arrowShift + 'px');
      tip.classList.toggle('is-flipped', flipped);

      tip.style.left = left + 'px';
      tip.style.top = top + 'px';

      activeTarget = trigger;
    }

    function hideTooltip() {
      if (tooltip) tooltip.classList.remove('is-visible');
      activeTarget = null;
    }

    document.addEventListener('mouseover', (e) => {
      const trigger = e.target.closest('.variant-option__tooltip-trigger');
      if (trigger) showTooltip(trigger);
    });

    document.addEventListener('mouseout', (e) => {
      if (e.target.closest('.variant-option__tooltip-trigger')) hideTooltip();
    });

    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('.variant-option__tooltip-trigger');
      if (!trigger) {
        hideTooltip();
        return;
      }
      if (activeTarget === trigger) {
        hideTooltip();
      } else {
        showTooltip(trigger);
      }
    });

    // If a dialog the tooltip lives in gets closed while the tooltip is
    // still visible, hide it so it doesn't linger detached/orphaned.
    document.addEventListener('close', (e) => {
      if (e.target.tagName === 'DIALOG' && tooltip && e.target.contains(tooltip)) {
        hideTooltip();
      }
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["modal"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    console.log(customElements.get('scx-modal'));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["toworkfor-share-button"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function () {
  const openBtn = document.querySelector('.open-share-modal');
  const modal = document.querySelector('.share-modal');
  const overlay = document.querySelector('.share-modal__overlay');
  const closeBtn = document.querySelector('.share-modal__close');
  const copyBtn = document.querySelector('.copy-link-btn');
  const content = document.querySelector('.share-modal__content');

  let scrollY = 0;

  // Helper function to wait for animation end
  function waitForAnimationEnd(element) {
    return new Promise((resolve) => {
      const handleAnimationEnd = () => {
        element.removeEventListener('animationend', handleAnimationEnd);
        element.removeEventListener('transitionend', handleAnimationEnd);
        resolve();
      };
      
      element.addEventListener('animationend', handleAnimationEnd, { once: true });
      element.addEventListener('transitionend', handleAnimationEnd, { once: true });
      
      // Fallback timeout in case animation doesn't trigger
      setTimeout(resolve, 400);
    });
  }

  function openModal() {
    scrollY = window.scrollY;

    requestAnimationFrame(() => {
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = '100%';
      document.body.classList.add('share-modal-open');

      modal.classList.add('active');
      modal.setAttribute('aria-hidden', 'false');
      closeBtn.focus();
    });
  }

  async function closeModal() {
    // Add closing class to trigger reverse animation
    modal.classList.add('closing');

    // Wait for the animation to complete before unlocking scroll
    await waitForAnimationEnd(content);

    modal.classList.remove('active', 'closing');
    modal.setAttribute('aria-hidden', 'true');

    document.body.classList.remove('share-modal-open');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    
    // Restore scroll position instantly (no animation)
    window.scrollTo({ top: scrollY, behavior: 'instant' });
  }

  openBtn.addEventListener('click', openModal);
  closeBtn.addEventListener('click', closeModal);
  overlay.addEventListener('click', closeModal);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('active')) {
      closeModal();
    }
  });

  // Copy link
  copyBtn.addEventListener('click', () => {
    navigator.clipboard.writeText(window.location.origin);
    copyBtn.textContent = "Copied!";
    setTimeout(() => copyBtn.textContent = "Copy link", 2000);
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["toworkor-modal-imagentext"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", ()=>{

  console.log(customElements.get('scx-modal'));
})
  } catch(e) { console.error(e); }
})();

})();
